import {useEffect, useState} from "react";
import {Client} from "../Api/Client";
import Accordion from "../Components/Accordion";
import Spinner from "../Components/Spinner";
import LineChart from "../Components/LineChart";

function LineChartSection({content}: any) {
    const [isLoading, setIsLoading] = useState(false);
    const [sectionData, setSectionData] = useState<any>([]);

    async function getSectionData (signal: any) {
        setIsLoading(true);
        Client.get(content.endpoint, { signal: signal })
            .then((response) => {
                setSectionData(response.data.data)
                setTimeout(() => setIsLoading(false), 250);
            })
            .catch((e) => {
                console.log(e.message)
            })
    }

    useEffect(() => {
        const abortController = new AbortController();
        getSectionData(abortController.signal)

        return () => abortController.abort();
    }, [content.endpoint])

    return (
        <div className="relative">
            {isLoading && <Spinner />}
            <Accordion icon={content.icon} title={content.title} description={content.text}>
                <div className="max-h-[300px] w-full pt-4">
                    <LineChart data={sectionData} />
                </div>
            </Accordion>
        </div>
    );
}

export default LineChartSection;